export function initMailRuTop() {
  window._tmr = window._tmr || [];
  _tmr.push({ id: "3259545", type: "pageView", start: (new Date()).getTime() });

  if (document.getElementById("tmr-code")) return;

  const ts = document.createElement("script");
  ts.type = "text/javascript";
  ts.async = true;
  ts.id = "tmr-code";
  ts.src = "https://top-fwz1.mail.ru/js/code.js";
  const f = function() {
    const s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(ts, s);
  };
  if (window.opera === "[object Opera]") {
    document.addEventListener("DOMContentLoaded", f, false);
  } else {
    f();
  }
}
